// https://github.com/lancedikson/bowser/blob/master/src/constants.js

import bowser from 'bowser'

const osMap = bowser.OS_MAP
const engineMap = bowser.ENGINE_MAP
const platformMap = bowser.PLATFORMS_MAP

const parser = bowser.getParser(window.navigator.userAgent)
const os = parser.getOSName()
const engine = parser.getEngineName()
const platform = parser.getPlatformType()

export default {
  // os
  iOS: os === osMap.iOS,
  macOS: os === osMap.MacOS,
  Android: os === osMap.Android,
  // engine
  Gecko: engine === engineMap.Gecko,
  Blink: engine === engineMap.Blink,
  WebKit: engine === engineMap.WebKit,
  likeIE: engine === engineMap.Trident || engine === engineMap.EdgeHTML,
  // platform
  likeDesktop: platform === platformMap.desktop,
  likeMobile: platform !== platformMap.desktop
}
